<template>
  <div>
    <label class="pull-left">{{ $t("b2c.selectedInvoicer") }}</label>

    <div class="row custom-datalist" v-click-outside="hideList">
      <input
        @focus="showList"
        @blur="hideList"
        @keyup.down="down"
        @keyup.enter="selectEnter(index)"
        @keyup.up="up"
        :placeholder="$t('b2c.selectInvoicer')"
        class="custom-datalist-input form-control"
        :class="{ 'no-shadow': selected }"
        v-model="searchText"
        :disabled="selected"
      />
      <div class="search-icon">
        <i class="fa fa-search"></i>
      </div>
      <div class="selected-card" v-if="selected">
        <div class="select-text">{{ custName }}</div>
        <i @click="unselect" class="fa fa-times close"></i>
      </div>
      <div v-if="show" class="datalist">
        <div
          v-on:click.stop
          v-for="(item, key) in filteredCustomers"
          @mouseenter="mouseOver(key)"
          @mouseleave="index = null"
          :key="key"
          @click.stop="select(key)"
          class="datalist-item"
          v-bind:class="{ selected: key === index }"
          v-on:keyup.down="down(key)"
          v-on:keyup.up="up(key)"
        >
          {{ item.vatid }}
          <div class="item-name-wrap">
            <span class="item-name">{{ item.name }}</span>
          </div>
        </div>
        <div class="text-error" v-if="filteredCustomers.length === 0">
          {{ $t("b2c.texts.noResults") }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "CustomerSelectInput",
  props: ["input", "valid", "customers", "disabled", "selected"],

  data() {
    return {
      placeholder: { customerNumber: "", name: "" },
      show: false,
      index: null,
      loading: false,
      searchText: "",
      total: 0,
    };
  },
  computed: {
    custName: function () {
      return this.selected.vatid + " " + this.selected.name;
    },
    upperBound: function () {
      return this.customers.length - 1;
    },
    filteredCustomers: function () {
      if (this.searchText) {
        return this.customers
          .filter((c) => {
            return (
              c.name.toLowerCase().includes(this.searchText.toLowerCase()) ||
              c.vatid.includes(this.searchText)
            );
          })
          .sort((a, b) => this.nameSort(a, b));
      } else {
        return this.customers.map((c) => c).sort((a, b) => this.nameSort(a, b));
      }
    },
  },
  methods: {
    nameSort: function (a, b) {
      if (a.name < b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
      return 0;
    },
    down: function (key) {
      if (this.index === null) {
        this.index = 0;
      } else if (this.index < this.upperBound) {
        this.index++;
      }
    },
    up: function (key) {
      if (this.index > 0) {
        this.index--;
      }
    },
    mouseOver: function (key) {
      this.index = key;
    },
    showList: function () {
      this.show = true;
      this.index = null;
    },
    hideList: function () {
      if (this.index === null) {
        this.show = false;
        this.index = null;
      }
    },
    selectEnter: function (key) {
      if (key !== null) {
        this.select(key);
      }
    },
    select: function (key) {
      this.placeholder = this.filteredCustomers[key];
      this.$emit("selectInvoicer", this.filteredCustomers[key]);
      this.index = null;
      this.hideList();
    },
    unselect: function () {
      this.placeholder = { vatid: "", name: "" };
      this.$emit("selectInvoicer", null);
    },
  },
};
</script>

<style scoped>
.custom-datalist:focus-within .search-icon {
  display: none;
}
.input-group {
  width: 100%;
}

.selected-card {
  display: flex;
  flex-direction: row;
  padding: 3px 10px 3px 10px;
  border-radius: 20px;
  background: gray;
  position: absolute;
  top: 0px;
  width: 100%;
  box-shadow: 1px 2px 1px 0px black;
}
.selected-card .close {
  font-size: 16px;
  cursor: pointer;
}
.select-text {
  color: white;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.selected-card i {
  margin-left: auto;
  margin-top: 5px;
}
.yellow {
  color: #f5cc27;
  line-height: 1.3;
}
.selected {
  background-color: rgba(0, 0, 0, 0.1);
}
.custom-datalist {
  position: relative;
  width: 100%;
}
.datalist {
  width: 100%;
  max-height: 300px;
  overflow: auto;
  z-index: 1;
  position: absolute;
  top: 34px;
  left: 0;
  list-style: none;
  margin: 0;
  padding: 0;
  box-shadow: 2px 4px 6px hsla(0, 0%, 0%, 0.4);
  background-color: white;
  border-radius: 5px;
}
.datalist-item {
  display: flex;
  flex-direction: row;
  /*   display: block;
 */
  text-align: left;
  padding: 3px 10px 3px 10px;
  color: #41474e;
}
.item-name {
  font-size: 12px;
  /*   text-overflow: ellipsis;
    overflow: hidden;
  white-space: nowrap; */
  color: #76787a;
}

.item-name-wrap {
  margin-left: 5px;
  width: 70%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.custom-datalist-input {
  width: 100%;
  color: #495057;
  height: 31.5px;
  border-radius: 20px;
  padding: 0 2em 0 1em;
  font-size: 0.875rem;
  line-height: 1.5;
  box-shadow: 1px 2px 1px 0px black;
  margin-bottom: 0.5rem;
}

.no-shadow {
  box-shadow: none;
}
.custom-datalist-input:focus {
  box-shadow: none;
}
.list-end-item {
  color: #41474e;
  font-size: 14px;
}
.search-field > input {
  width: 100%;
}
.search-field:focus-within .search-icon {
  display: none;
}
.input-group {
  width: 100%;
}

.search-icon {
  position: absolute;
  right: 10px;
  top: 2.5px;
  font-size: 20px;
  color: hsla(0, 0%, 0%, 0.4);
}
.feedback-icon {
  bottom: 5px !important;
  right: 10px;
}
@media screen and (max-width: 376px) {
  .custom-datalist-input {
    box-shadow: none;
  }
}
</style>
